import React, { useCallback, useEffect, useState } from 'react';
import Axios from '../../api/axios';
import { useTabActions } from '../../contexts/tab-navigation';
import AiWhatsAppKuyruk from '../../pages/AI_WHATSAPP_KUYRUK/ai_whatsapp_kuyruk';
import './ai-whatsapp-badge.scss';
import { subscribeNotifications } from '../../services/notificationService';
import { publishBandCount } from '../../utils/browserBandNotification';

export default function AiWhatsAppBadge() {
  const [count, setCount] = useState(0);
  const { openDetailTab } = useTabActions();
  const refresh = useCallback(async () => {
    try {
      const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}report/ai_whatsapp_ozet`);
      const pending = Number(res.data?.pending || 0);
      setCount(pending);
      publishBandCount('ai-whatsapp', pending, {
        title: 'AI WhatsApp',
        body: pending === 1
          ? '1 müşteri için yeni arama kaydı bekleniyor'
          : `${pending} müşteri için yeni arama kaydı bekleniyor`,
      });
    } catch { /* header sessiz kalsın */ }
  }, []);
  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, 30000);
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    window.addEventListener('ai-cvp-refresh', onFocus);
    window.addEventListener('cari-sync-updated', onFocus);
    const unsubscribe = subscribeNotifications(n => { if (n?.type === 'SYNC_INVALIDATE') refresh(); });
    return () => {
      clearInterval(timer); window.removeEventListener('focus', onFocus);
      window.removeEventListener('ai-cvp-refresh', onFocus);
      window.removeEventListener('cari-sync-updated', onFocus);
      unsubscribe();
    };
  }, [refresh]);
  return <button type="button" className="ai-whatsapp-badge" title={`AI CVP: ${count} müşteri için yeni arama kaydı bekleniyor`}
    onClick={() => openDetailTab('ai-whatsapp-kuyruk', 'AI WhatsApp', AiWhatsAppKuyruk)}>
    <span className="ai-whatsapp-badge__icon" aria-hidden>AI CVP</span>
    <span className="ai-whatsapp-badge__wa" aria-hidden>◉</span>
    <span className="header-notification-label">WhatsApp</span>
    <span className="ai-whatsapp-badge__count">{count}</span>
  </button>;
}
